/*
 * Errores 422 del guardado en lote (LMS-218). Laravel los devuelve con la ruta
 * del campo dentro de la lista (`blocks.2.data.url`); el editor los quiere por
 * bloque y con la misma clave que tendrían al validar un bloque suelto (`data.url`).
 */
const BLOCK_ERROR = /^blocks\.(\d+)\.(.+)$/

// { 'blocks.2.data.url': [...] } → { 2: { 'data.url': [...] } }
export const groupBlockErrors = (errors) => Object.entries(errors ?? {}).reduce((grouped, [field, messages]) => {
    const match = BLOCK_ERROR.exec(field)
    if (!match) return grouped

    const [, index, blockField] = match
    grouped[index] = {...(grouped[index] ?? {}), [blockField]: messages}
    return grouped
}, {})

export const firstMessage = (fieldErrors) => Object.values(fieldErrors).flat()[0] ?? ''
